// @ts-nocheck

function rpOnReady(fn) {
    if (typeof fn !== 'function') return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
}

export function initAppTooltip() {

(function () {
    'use strict';

    if (window.__appTooltipInitialized) {
        return;
    }
    window.__appTooltipInitialized = true;

    var tooltipEl = null;
    var currentTarget = null;
    var showTimer = null;

    function ensureTooltip() {
        if (tooltipEl) return tooltipEl;
        tooltipEl = document.createElement('div');
        tooltipEl.className = 'app-tooltip';
        tooltipEl.setAttribute('role', 'tooltip');
        tooltipEl.setAttribute('aria-hidden', 'true');
        document.body.appendChild(tooltipEl);
        return tooltipEl;
    }

    function position(target) {
        if (!tooltipEl) return;
        var rect = target.getBoundingClientRect();
        var tipRect = tooltipEl.getBoundingClientRect();
        var margin = 10;
        var viewportW = window.innerWidth;
        var viewportH = window.innerHeight;

        var top = rect.top - tipRect.height - margin;
        var placement = 'top';
        if (top < 8) {
            top = rect.bottom + margin;
            placement = 'bottom';
        }

        var left = rect.left + (rect.width / 2) - (tipRect.width / 2);
        var minLeft = 8;
        var maxLeft = viewportW - tipRect.width - 8;
        if (left < minLeft) left = minLeft;
        if (left > maxLeft) left = maxLeft;

        var arrowX = rect.left + (rect.width / 2) - left;
        if (arrowX < 14) arrowX = 14;
        if (arrowX > tipRect.width - 14) arrowX = tipRect.width - 14;

        tooltipEl.style.top = Math.round(top) + 'px';
        tooltipEl.style.left = Math.round(left) + 'px';
        tooltipEl.style.setProperty('--app-tooltip-arrow-x', Math.round(arrowX) + 'px');
        tooltipEl.setAttribute('data-placement', placement);

        if (top + tipRect.height > viewportH - 4) {
            tooltipEl.style.top = Math.max(8, viewportH - tipRect.height - 8) + 'px';
        }
    }

    function show(target) {
        var text = target.getAttribute('data-tooltip');
        if (!text) return;
        ensureTooltip();
        currentTarget = target;
        tooltipEl.textContent = text;
        tooltipEl.style.left = '0px';
        tooltipEl.style.top = '0px';
        tooltipEl.classList.add('is-visible');
        tooltipEl.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
            if (currentTarget === target) position(target);
        });
    }

    function hide() {
        currentTarget = null;
        if (!tooltipEl) return;
        tooltipEl.classList.remove('is-visible');
        tooltipEl.setAttribute('aria-hidden', 'true');
    }

    function findTarget(node) {
        while (node && node !== document.body) {
            if (node.nodeType === 1 && node.hasAttribute && node.hasAttribute('data-tooltip')) {
                return node;
            }
            node = node.parentNode;
        }
        return null;
    }

    document.addEventListener('mouseover', function (e) {
        var target = findTarget(e.target);
        if (!target || target === currentTarget) return;
        clearTimeout(showTimer);
        showTimer = setTimeout(function () { show(target); }, 120);
    });

    document.addEventListener('mouseout', function (e) {
        var target = findTarget(e.target);
        if (!target) return;
        var to = e.relatedTarget;
        if (to && target.contains(to)) return;
        clearTimeout(showTimer);
        hide();
    });

    document.addEventListener('focusin', function (e) {
        var target = findTarget(e.target);
        if (!target) return;
        show(target);
    });

    document.addEventListener('focusout', function (e) {
        var target = findTarget(e.target);
        if (!target) return;
        hide();
    });

    window.addEventListener('scroll', hide, true);
    window.addEventListener('resize', hide);
})();

}
